export default __webpack_public_path__ + "static/media/bi_D.8e8e733d.svg";